import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { getDayWeeklyRankComment } from '../../../../../services/api.js';

class TopItem extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { doc_name, doc_url, comments_count_now },
        } = this.props;

        return (
            <li>
                <p>
                    <a href={doc_url} target="_blank">
                        {doc_name}
                    </a>
                </p>{' '}
                <p className={styles.cItemNum}>{comments_count_now}</p>{' '}
            </li>
        );
    }
}

class TopRank extends PureComponent {
    state = {
        current: 'day',
        dayTop: [],
        weekTop: [],
    };

    handleTabClick = current => {
        this.setState({
            current,
        });
    };

    async componentDidMount() {
        const rankRes = await getDayWeeklyRankComment();

        if (rankRes) {
            this.setState({
                ...this.state,
                ...rankRes,
            });
        }
    }

    render() {
        const wrapTitle = [
            {
                title: '本日热评',
                key: 'day',
            },
            {
                title: '本周热评',
                key: 'week',
            },
        ];
        const { current, dayTop, weekTop } = this.state;

        return (
            <div className={styles.hotCommentList}>
                <div className={styles.tabBox}>
                    <span className={styles.hotIcon} />
                    <ul className={styles.tabsLine}>
                        {wrapTitle.map(item => (
                            <li
                                key={item.key}
                                className={`${styles.wTab} ${current === item.key ? styles.currentTab : null}`}
                                onClick={() => this.handleTabClick(item.key)}>
                                {item.title}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={styles.sheets}>
                    <ul>
                        {current === 'day'
                            ? dayTop.map((item, index) => <TopItem content={item} key={index} />)
                            : weekTop.map((item, index) => <TopItem content={item} key={index} />)}
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(TopRank);
